import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ServiceFinder from '../components/ServiceFinder';
import ProcessSteps from '../components/ProcessSteps';
import Testimonials from '../components/Testimonials';
import ContactSection from '../components/ContactSection';
import NewsletterSection from '../components/NewsletterSection';
import Footer from '../components/Footer';
import AnnouncementBanner from '../components/AnnouncementBanner';
import RichMediaAnnouncementModal from '../components/RichMediaAnnouncementModal';
import ChatbotWidget from '../components/ChatbotWidget';

const Home = () => {
  const [selectedCountry, setSelectedCountry] = useState('');

  const clearCountrySelection = () => {
    setSelectedCountry('');
  };

  return (
    <div className="home-page">
      <AnnouncementBanner />
      {/* Announcements handled by AnnouncementBanner component */}
      <Header onBookConsultation={clearCountrySelection} />
      <Hero />
      <ServiceFinder onClearCountry={clearCountrySelection} />
      {/* GetVisaSection removed - destinations now available on Apply Online page */}
      <ProcessSteps />
      <Testimonials />
      <ContactSection preSelectedCountry={selectedCountry} />
      <NewsletterSection />
      <Footer />
      <ChatbotWidget />
    </div>
  );
};

export default Home;
